const legalNotices = {
  title: "MENTIONS LÉGALES",
  intro: {
    title: "UTILISATION DES SERVICES",
    paragraphs: [
      "La société iizenglish a pour activité le développement, l’édition et vente d’application Web et mobile à visée pédagogique et à destination des professionnels, organismes, institutions et particuliers.",
      "L’accès et l’utilisation de l’application Web iizenglish sont soumis aux conditions figurant ci-après ainsi qu’aux dispositions légales en vigueur.",
      "En accédant au Site, l’utilisateur accepte, sans limitation ni réserves, ces conditions.",
    ],
  },
  editor: {
    title: "ÉDITEUR DU SITE",
    paragraphs: [
      "Raison sociale : Société iizenglish SAS – 883 506 024 R.C.S. Paris",
      "Forme juridique : Société par actions simplifiée au capital de 1000 €",
      "Siège social : 23, avenue Foch, 75116 Paris",
      "N° TVA Intra-communautaire : FR75881212138",
      "Directeur de la publication : Hervé Chevènement",
      "Pour nous contacter : rendez-vous sur la page Contact.",
    ],
  },
  contactingUs: {
    title: "NOUS CONTACTER",
    paragraphs: [
      "23, avenue Foch, 75116 Paris, France",
      "+33 (0)6 50 70 87 21",
      "contact@iizenglish.com",
    ],
  },
  host: {
    title: "HÉBERGEUR",
    paragraphs: [
      "GETCAAS<br /> 12 rue Albert Einstein<br /> 48000 Mende - France<br />",
      "Pour contacter cet hébergeur, rendez-vous à l’adresse https://www.getcaas.io/<br />",
    ],
  },
  attributions: {
    title: "CRÉDITS",
    paragraphs: [
      "Développement : Coopdev<br /> Intégration web : Maëva Rouxel<br /> Graphisme : La Petite Planète<br /> Illustration : Bod’Z<br />",
    ],
  },
  intellectualProperty: {
    title: "PROPRIÉTÉ INTELLECTUELLE",
    paragraphs: [
      "La structure générale ainsi que les textes, images animées, son savoir-faire et tous les autres éléments composant le site sont la propriété exclusive de iizenglish.",
      "Les logos et marques des sociétés citées sur le site sont la propriété exclusive de leurs auteurs respectifs.",
      "Toute représentation, reproduction, et/ou exploitation, qu’elle(s) soi(en)t partielle(s) ou totale(s), des marques précitées est (sont) interdite(s), sauf accord écrit et préalable de leurs titulaires.",
    ],
  },
  copyrights: {
    title: "DROITS D'AUTEUR",
    paragraphs: [
      "Toute représentation totale ou partielle de ce site par quelle que personne que ce soit, sans l’autorisation expresse de iizenglish est interdite et constituerait une contrefaçon sanctionnée par les articles L. 335-2 et suivants du Code de la propriété intellectuelle.",
      "L’élaboration de liens hypertextes profonds vers le site www.iizenglish.com est interdite sans l’accord exprès et préalable de l’éditeur du site www.iizenglish.com.",
      "Par ailleurs, l’utilisation des informations contenues sur le présent site relève de la seule responsabilité de l’utilisateur. Nous ne pourrions en aucun cas, et pour quelque cause que ce soit, en être tenus pour responsables, et ce, quelles qu’en soit les conséquences.",
      "Nous ne sommes responsables d’aucune erreur ou omission sur le présent site.",
    ],
  },
  warning: {
    title: "AVERTISSEMENT GÉNÉRAL",
    paragraphs: [
      "La consultation du site www.iizenglish.com est proposée aux internautes à titre gratuit et sans aucune garantie de la part de son éditeur.",
      "Les informations disponibles sur le site qui proviennent de sources extérieures ne saurait garantir qu’elles sont exemptes d’erreurs, ni garantir leur complétude, leur actualité, leur exhaustivité ou autre.",
      "En conséquence, il appartient à l’internaute d’utiliser les informations figurant sur le site Internet à ses risques et de procéder à toute vérification sous sa responsabilité exclusive.",
      "iizenglish ne serait être tenu responsable de l’interprétation faite par les internautes, quelle qu’elle soit, de tous les renseignements, informations et conseils proposés sur son blog, et des conséquences pouvant en découler.",
      "Les propriétaires des sites marchands, de service, sites persos, sites informatiques (etc.) consultés à partir du site  sont seuls responsables du respect par eux de l’ensemble des réglementations s’appliquant dans le cadre des prestations offertes aux clients finaux, et notamment, des lois et règlements relatifs à :",
      [
        "La vente à distance",
        "La protection du consommateur",
        "La publicité mensongère ou trompeuse",
        "Les prix",
        "La conformité des produits",
      ],
    ],
  },
};

export default legalNotices;
